import ConnectivityPage from '@components/connectivity/ConnectivityPage';
import GoogleMapScript from './scripts/GoogleMapScript';
import { ConnectivityActionTypes } from '@state/features/common.types';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
const ConnectivityApp = (props) => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch({ type: ConnectivityActionTypes.FETCH_CONNECTIVITYDATA });
    }, []);
    return (React.createElement(GoogleMapScript, Object.assign({}, props),
        React.createElement(ConnectivityPage, Object.assign({}, props))));
};
export default ConnectivityApp;
